import React, { useState } from "react";
import { toast } from "sonner";
import { Files } from "@phosphor-icons/react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { blobError, canGetConsentProof, saveBlob } from "./ConsentProofButton";

const MAX = 100;

// One ZIP for a dispute: all proofs in one PDF, a PDF per lead, and a summary CSV.
export function ProofPackButton({ leadIds, testId = "proof-pack-btn" }) {
  const { user, hasPerm } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!leadIds.length || !canGetConsentProof(user, hasPerm)) return null;
  const run = async () => {
    if (leadIds.length > MAX) return toast.error(`Pick up to ${MAX} leads for one pack`);
    setBusy(true);
    try {
      const resp = await api.post("/leads/consent-proof-pack", { lead_ids: leadIds }, { responseType: "blob" });
      saveBlob(resp, "dispute-proof-pack.zip");
      toast.success("Proof pack downloaded");
    } catch (err) {
      toast.error((await blobError(err)) || "Couldn't build the proof pack");
    } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={run} disabled={busy} data-testid={testId}
      title="ZIP with every consent proof in one PDF, a PDF per lead and a summary spreadsheet"
      className="inline-flex items-center gap-1 border-2 border-sky-800 bg-sky-50 px-2 py-1 text-[10px] uppercase tracking-widest text-sky-900 transition-colors duration-100 hover:bg-sky-800 hover:text-white disabled:opacity-40">
      <Files size={12} weight="bold" /> {busy ? "Building…" : `Proof pack (${leadIds.length})`}
    </button>
  );
}
